import { isEmpty } from 'lodash-es';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractControl, Validators, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  constructor(private translate: TranslateService) {}

  getValidatorErrorMessage(validatorName: string): string {
    const config: any = {
      required: this.translate.instant('required')
    };

    return config[validatorName];
  }

  email(control: AbstractControl): { [key: string]: boolean } | null {
    // eslint-disable-next-line max-len
    const emailPatternRegExp: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailError: ValidationErrors = Validators.pattern(emailPatternRegExp)(control);
    return isEmpty(emailError) ? null : emailError;
  }

  nationalId(nationalId: string): boolean {
    let sum: number = 0;
    const firstDigit: string = nationalId.charAt(0);

    if (firstDigit === '0') {
      return false;
    }

    for (let i: number = 0; i < 12; i++) {
      sum += parseInt(nationalId.charAt(i), 10) * (13 - i);
    }

    return (11 - (sum % 11)) % 10 === parseInt(nationalId.charAt(12), 10);
  }

  mobileNumber(control: AbstractControl): { [key: string]: any } | null {
    let error: any = null;
    const minLengthError: ValidationErrors = Validators.minLength(10)(control);
    const maxLengthError: ValidationErrors = Validators.maxLength(10)(control);
    error = { ...minLengthError, ...maxLengthError };

    // const notNumberStartWithZeroRegex: RegExp = /^[1-9][0-9]*/i;
    const onlyNumberRegex: RegExp = /^[0-9]*$/i;
    if (control.value && !control.value.match(onlyNumberRegex)) {
      return { ...error, mobileNumber: true };
    }
    return isEmpty(error) ? null : error;
  }
}
